<template>
  <!-- <v-col class="text-center xs offset-xs">
    <v-col class="mb-4 mt-5 xs">
      <h2 style="font-size:30px;font-weight:300;">
        Bring your data from anywhere with our intergrations
      </h2>
    </v-col>
    <v-col class="xs offset-xs">
      <v-text-field
        v-model="searchIntegration"
        solo
        label="Search for your integration..."
        prepend-inner-icon="mdi-magnify"
        :clearable="true"
      />
    </v-col>
    <v-col class="xs">
      <template v-if="listItems && !listItems.length > 0 && !newElementsLoading">
        <div color="grey lighten-2">
          <v-container class="fill-height">
            <v-row align="center">
              <v-col>
                <h3 class="display-3">
                  Integrations
                </h3>
                <span class="subheading">Problem loading elements.</span>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </template>
      <template v-else>
        <v-slide-x-transition
          leave-absolute
          group
          class="wrap"
        >
          <v-row key="integrationList">
            <v-col
              v-for="item in filteredItems"
              :key="item.id"
              class="pa"
              cols="3"
            >
              <integration-card
                :integration="item"
                :minimized="hideDetails"
              />
            </v-col>
          </v-row>
        </v-slide-x-transition>
        <div v-if="filteredItems.length<=0 && !newElementsLoading">
          <h2>We don't have the intergration you're looking for at this very moment.</h2>
          <br>Feel free to contact us if you need an integration that is not available in this list.
        </div>
        <mugen-scroll
          :handler="fetchData"
          :should-handle="!newElementsLoading"
        >
          <template v-if="nextPage!==null">
            Loading new elements...
          </template>
        </mugen-scroll>
      </template>
    </v-col>
    <v-progress-circular
      v-show="newElementsLoading"
      indeterminate
      size="80"
      color="primary"
      style="margin-top:50px;"
    />
  </v-col> -->
</template>
<script>
  import IntegrationCard from '../../../UIComponents/Cards/IntegrationCard.vue'
  import IntegrationService from './services/IntegrationService'
  import MugenScroll from 'vue-mugen-scroll'
  export default {
    components: {
      IntegrationCard,
      MugenScroll,
    },
    data: function () {
      return {
        listItems: [],
        newElementsLoading: true,
        nextPage: null,
        callNumber: 0,
        hideDetails: false,
        searchIntegration: '',
      }
    },
    computed: {
      filteredItems: function () {
        let temp = []
        if (
          this.searchIntegration
            ? this.searchIntegration.replace(' ', '').length > 0
            : false
        ) {
          temp = this.listItems.filter(integration => {
            return integration.name
              .toLowerCase()
              .includes(this.searchIntegration.toLowerCase())
          })
        } else temp = this.listItems

        return _.orderBy(temp, 'config_id', 'asc')
      },
    },
    mounted: function () {
      // callNumber is used to determine how many times we called the backend to know
      // which page we are on.
      this.callNumber++
      var t = this
      this.newElementsLoading = true
      IntegrationService.list(this, 0)
        .then(function (response) {
          if (response.data.results.length) {
            t.listItems = response.data.results
          }
          if (response.data.next !== null) {
            t.nextPage = response.data.next
          } else {
            t.nextPage = null
          }
        })
        .catch(function (error) {
          t.$store.commit('push', { msg: error, color: 'error' })
        })
        .finally(() => {
          t.newElementsLoading = false
        })
    },
    methods: {
      // fetchData is called when you want to load additional elements by making a call to the back
      fetchData () {
        this.newElementsLoading = true
        var t = this
        if (t.nextPage !== null) {
          // We check that the next page corresponds to the current call number + 1 to avoid
          // loading the same elements that are already loaded (because of how the mugen scroll
          // seems to work). This solution works but can probably be made more elegant.
          if (t.nextPage.endsWith(t.callNumber + 1)) {
            t.callNumber++
            IntegrationService.list(t, t.nextPage)
              .then(function (response) {
                var res = response.data.results
                var item
                for (item in res) {
                  t.listItems.push(res[item])
                }
                if (response.data.next !== null) {
                  t.nextPage = response.data.next
                } else {
                  t.nextPage = null
                }
              })
              .catch(function (error) {
                console.log('error')
              })
              .finally(() => {
                this.newElementsLoading = false
              })
          }
        }
      },
      handleTyping: function (newValue) {
        this.searchIntegration = newValue
      },
      handleHide: function (newValue) {
        this.hideDetails = newValue
      },
    },
  }
</script>
